<template lang="pug">
.cp-robot
  #link-robot2s
  transition(name="fadeUp")
    .tabs.fixed(v-show="!isTabsVisible")
      router-link(:to="'/robot2s/info'") 功能
      router-link(:to="'/robot2s/design'") 设计
      router-link(:to="'/robot2s/spec'") 技术规格
  .tabs#tabs
    router-link(:to="'/robot2s/info'") 功能
    router-link(:to="'/robot2s/design'") 设计
    router-link(:to="'/robot2s/spec'") 技术规格
  router-view
//- vdvdvfdvfd
</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      isTabsVisible: true,
    }
  },
  computed: {},
  methods: {
    handleTab (index) {
      this.tab = index
    }
  },
  created () {
    $(window).on('scroll', () => {
      this.isTabsVisible = isVisible('#tabs')
    })
  }
}
</script>

<style lang="stylus">
@import 'config'
.cp-robot
  .tabs
    width 100%
    text-align center
    height 48px
    line-height 48px
    border-top 1px solid $bdcolor
    box-shadow 0 3px 10px $bdcolor
    &.fixed
      position fixed
      top 0
      left 0
      background rgba(255,255,255,.8)
      z-index 10
    a
      display inline-block
      margin 0 18px
      cursor pointer
      font-size 14px
      &.router-link-active
        color $blue

</style>



// WEBPACK FOOTER //
// src/views/robot/2s/index.vue